import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const useActiveSection = (sections) => {
  const { pathname } = useLocation();

  const activeSection = useMemo(() => {
    if (!sections || sections.length === 0) return null;

    // First try to match panel items (most specific)
    for (const section of sections) {
      if (section.panelItems) {
        for (const item of section.panelItems) {
          if (item.children) {
            for (const child of item.children) {
              if (child.link && pathname === child.link) {
                return section.id;
              }
            }
          }
          if (item.link && pathname === item.link) {
            return section.id;
          }
        }
      }
    }

    // Then try prefix matching on section links
    for (const section of sections) {
      if (section.link && pathname.startsWith(section.link)) {
        return section.id;
      }
      if (section.panelItems) {
        for (const item of section.panelItems) {
          if (item.link && pathname.startsWith(item.link)) {
            return section.id;
          }
        }
      }
    }

    // Default to first section
    return sections[0]?.id || null;
  }, [sections, pathname]);

  return activeSection;
};

export default useActiveSection;
